const mixin = {
	breadcrumbsLead: [{
		text: 'Главная',
		to: { path: '/' },
	}],

	computed: {
		breadcrumbs () {
			const list = [ ...this.$options.breadcrumbsLead ];
			return list;
		},
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/breadcrumb-mixin.js